import { Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CalendarService } from 'src/app/services/utilities/calendar.service';
import { CalenderBaseComponent } from 'src/app/components/base/calendar.component';
import { PostService } from 'src/app/services/repositories/post.service';
import { TranslationService } from 'src/app/services/utilities/translation.service';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';
import { CALENDERMODE } from 'src/app/interfaces/CalendarMode';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-day-posts-preview',
  templateUrl: './day-posts-preview.component.html',
  styleUrls: ['./day-posts-preview.component.scss'],
  animations: [
		trigger('fadeAnimation', [
      state('true', style({ opacity: 1, display: 'flex' })), // Fully visible
      state('false', style({ opacity: 0, display: 'none' })), // Hidden
      transition('true => false', [animate('1s ease-out')]), // Fades out over 1 second
    ]),
  ],
})
export class DayPostsPreviewComponent extends CalenderBaseComponent{

  override data: any = [];
  @Input() selectedDayDate: string = '';
  @Input() selectedDate: string = '';
  @Input() posts: any = null;
  @Input() totalPostsCount: number = 0;
  date: any;
  @Input() override groupScopes: any;
  @Input() user: any;
  @Input() xpos: number = 0;
  @Input() ypos: number = 0;
  @Input() isVisible: boolean = false;
  // private ignoreFirstClick = true;
  @Output() visibilityChange = new EventEmitter<boolean>();
  @Input() previewHeight!: number; // New input for 
  @Input()  override currentPlaTformsFilters: any = {
    isFacebookON: true,
    isLinkedinON: true,
    isGoogleON: true,
    isInstagramON: true,
  };
  insights: boolean = true;
  loadPost: boolean =  false;
	showLoadPostDiv: boolean = false;
  subscriptions: Subscription[] = [];


 constructor(
     protected override uiStateService: UiStateService,
     protected override postService: PostService,
     protected override translationService: TranslationService,
     protected override calendarService: CalendarService,
     private elementRef: ElementRef,
     private renderer: Renderer2
   ) {
     super(translationService, calendarService, postService, uiStateService);
   }

   override ngOnInit(){
    console.log("day posts preview init with selectedDate",this.selectedDate,"and selectedDayDate",this.selectedDayDate)
    console.log("initialData",this.data)
    // let activePlatforms = Object.keys(this.currentPlaTformsFilters).filter(key => this.currentPlaTformsFilters[key]).map(key => key.replace('is', '').replace('ON', '').toLowerCase());
    // this.postService.getByTimeFrame(this.groupScopes, this.selectedDate, 'day',activePlatforms).subscribe((res) => {
    //   if (res.data.length > 0) {
    //     this.data = res.data
    //   }});
    // setTimeout(() => {
    //   this.ignoreFirstClick = false; 
    // });
    if(this.selectedDate != ''){
      this.loadPost =  true
      this.date = new Date(this.selectedDate)
      let activePlatforms = Object.keys(this.currentPlaTformsFilters).filter(key => this.currentPlaTformsFilters[key]).map(key => key.replace('is', '').replace('ON', '').toLowerCase());
      this.subscriptions.push(this.postService
          .getByTimeFrame(this.groupScopes, this.selectedDate, 'day',activePlatforms)
          .subscribe((res) => {
            if (res.data.length > 0) {
              this.data = res.data
              this.loadPost =  false
            }
          }));
    }else{
      this.date = new Date(this.selectedDayDate)
    }
  }
checkifThereIsMoreTofetch(event:any){

  if(this.data.length==this.totalPostsCount)return
  // console.log("loaded data so far",this.data.length,"totalPostsCount",this.totalPostsCount)
  const element = event.target;
  // console.log("scrollTop",element.scrollTop,"scrollHeight",element.scrollHeight,"clientHeight",element.clientHeight)
  if (element.scrollHeight - element.scrollTop === element.clientHeight) {
    // console.log("scrolled to bottom, fetch more data if available")
    this.postService.getByTimeFrame(this.groupScopes, this.selectedDate, 'day',Object.keys(this.currentPlaTformsFilters).filter(key => this.currentPlaTformsFilters[key]).map(key => key.replace('is', '').replace('ON', '').toLowerCase()),this.data.length).subscribe((res) => {
      // console.log('fetched more data',res)
      if (res.data.length > 0) {
        this.data = this.data.concat(res.data)
      }
    })
  }
}
  switchToDayView(day: Date): void {
    // Debug.log("switching to month",month)
    this.calendarService.setCurrentDate(day);
    this.calendarService.setCurrentCalendarMode(CALENDERMODE.DAY);
  }
 
  switchToMonthView(month: number): void {
    // Debug.log("switching to month",month)
    this.calendarService.setCurrentMonth(month);
    this.calendarService.setCurrentCalendarMode(CALENDERMODE.MONTH);
  }

  switchToYearView(year: number): void {
    // Debug.log("switching to year",year)
    this.calendarService.setCurrentYear(year);
    this.calendarService.setCurrentCalendarMode(CALENDERMODE.YEAR);
  }
  
  close(){
    this.visibilityChange.emit(false)
  }

  getUniquePosts(data: any[]): any[] {
    const uniqueCombinations = new Set();
    const uniquePosts: any[] = [];
  
    for (const item of data) {
      item.title=item.title==""||item.title==undefined?"N/A":item.title
      const combo = `${item.title}-${item.text}-${item.typePost}`;
      if (!uniqueCombinations.has(combo)) {
        uniqueCombinations.add(combo);
        uniquePosts.push(item);
      }
    }
    return uniquePosts;
  }

  getTime(item: any) {
    const date: Date = item.expectedPublishingDatetime == null ? new Date(item.publishingDatetime) : new Date(item.expectedPublishingDatetime);
    return date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0');
  }

  getDate(item: any) {
    const date: Date = item.expectedPublishingDatetime == null ? new Date(item.publishingDatetime) : new Date(item.expectedPublishingDatetime);
    return date.getDate().toString().padStart(2, '0') + ' / ' + (date.getMonth() + 1).toString().padStart(2, '0') + " / " + date.getFullYear();
  }
  override getTranslation(key: string): string {
    return this.translationService.t(key);
  }
  allOff(post: any): boolean{
    if(post.SocialPlatforms.length==0)return false
    if(Object.values( this.currentPlaTformsFilters).every((value) => value === true))return true
    let platforms: any[] = [];

    post.SocialPlatforms.forEach((platform: any)=>{
      if(!platforms.includes(platform.source)){
        platforms.push(platform.source)
      }
    })
    
    console.log("platforms of post",platforms,this.currentPlaTformsFilters)
    return platforms.some((platform:string) => ((platform == 'facebook' && this.currentPlaTformsFilters.isFacebookON) || (platform == 'google' && this.currentPlaTformsFilters.isGoogleON) || (platform == 'linkedin' && this.currentPlaTformsFilters.isLinkedinON) || (platform == 'instagram' && this.currentPlaTformsFilters.isInstagramON)));
  }

  onAnimationDone(event: any): void {
    if (!this.loadPost) {
      this.showLoadPostDiv = false; // Remove the div after fade-out
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    // if (this.ignoreFirstClick) return; 

    if (!this.elementRef.nativeElement.contains(event.target)) {

      this.visibilityChange.emit(false); 
    }
  }

  override ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  displayAs(post: any): string {
		if (post) {
      if (new Date(post.expectedPublishingDatetime) > new Date()) {
				return 'planned';
			} 
      else if(post.expectedPublishingDatetime==null && post.publishingDatetime==null){
        return 'draft'
      }
      else if(post.SocialPlatforms.some((p:any)=>p.externalId==null)){
				return 'failed';
			}
      else {
        return "post"
      }
		} else {
			return ''
		}

	}

  extractHour(data: any): string{
    const date = data.publishingDatetime ? new Date(data.publishingDatetime): new Date(data.expectedPublishingDatetime);
    const postHour = date.getHours().toString().padStart(2,'0');
    const postMinute = date.getMinutes().toString().padStart(2,'0');
    return postHour+":"+postMinute
  }
}
